import { createStore, compose, applyMiddleware } from 'redux';
import { responsiveStoreEnhancer } from 'redux-responsive';

import firebase from 'lib/firebase';
import reducers from './reducers';
import { reactReduxFirebase } from 'react-redux-firebase'
import setLanguageMiddleware from './middlewares/setLanguage';
import { setLanguage } from 'store/language/actions';
import strings from 'lib/strings';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = compose(reactReduxFirebase(firebase, {
  userProfile: 'users',
  preserveOnLogout: ['wishes', 'willBuys', 'admins']
}))(createStore)(
  reducers,
  composeEnhancers(
    responsiveStoreEnhancer,
    applyMiddleware(setLanguageMiddleware)
  )
);

store.dispatch(setLanguage(strings.getInterfaceLanguage()));

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js